// deps
import React, { memo } from "react";

// styles
import { SeparatorLine } from "./BillSeparator.style";

// constants
import { PL_BILL_SEPARATOR_TEST_IDS } from "@swiggy-private/cart-test-ids";

const BillSeparator = () => <SeparatorLine data-testid={PL_BILL_SEPARATOR_TEST_IDS.SEPARATOR} />;

export default memo(BillSeparator);
